/* eslint-disable */
import React, { useState, useEffect } from 'react';
import A12Y_CONST from '../common/a12yConst';
import Loading from "./LoadingComponent";
import { useForm } from "react-hook-form";

function PopUpRenameComponent(props) {
    const [isPopUpVisible, setIsPopUpVisible] = useState(props.popUpStatus);
    const [title, setTitle] = useState('');
    const [loading, setLoading] = useState(false);
    const [folderName, setFolderName] = useState('');
    const [error, setErrors] = useState(false);
    const [isBtnDisabled, setIsBtnDisabled] = useState(false);
    const { register, handleSubmit, setFocus, setError, reset, formState: { errors, isSubmitting }, setValue } = useForm({ mode: "all" });

    useEffect(() => {
        setIsPopUpVisible(props.popUpStatus);
    }, [props.popUpStatus]);

    useEffect(() => {
        if (isPopUpVisible) {
            setFocus("folderName");
        }
    }, [setFocus, isPopUpVisible]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (props.selectedItem) {
            if (props.selectedItem.is_folder) {
                setTitle('Rename Folder');
            } else {
                setTitle('Rename File');
            }

            setFolderName(props.selectedItem.display_name);
            setValue('folderName', props.selectedItem.display_name);
        }
    }, [props.selectedItem]); // eslint-disable-line react-hooks/exhaustive-deps

    const hidePopUp = async () => {
        props.hidePopUp();
        await setFolderName('');
        await setValue('folderName', '');
        reset({
            folderName: ""
        });
    }

    const onSubmit = async () => {
        if (!error.folderName) {
            let obj = {
                id: props.selectedItem.id,
                display_name: folderName
            };
            props.itemRename(obj);
            await setFolderName('');
            setValue('folderName', '');
        }
    }

    const handlefolderName = (value) => {
        if (value.length >= 1) {
            setIsBtnDisabled(true);
        } else {
            setIsBtnDisabled(false);
        }
        if (value.length === 1 && value === " ") {
            return;
        } else {
            setValue("folderName", value);
            setFolderName(value);
        }
    }

    return (
        <div>
            {isPopUpVisible ?
                <div className='popTop documentPopUp'>
                    <div className='popContainer popMaxWidth'>
                        <div className='popMaster'>
                            <div className="popUpMainBg fullWidth">
                                <div className="cancelIcon fullWidth marginBottom10 marginTop30">
                                </div>
                                <div id={A12Y_CONST.BUTTON_ID.DOCUMENT_POPUP_TITLE} className={`areYouText marginBottom30 reNameTitle`}>
                                    {title}
                                </div>
                                <div className='emailVerficationMaxWidth documentFolder'>

                                    <div className={'positionRelative marginBottom30 maxWidth465 marginAuto'}>
                                        <input
                                            {...register('folderName', {
                                                required: A12Y_CONST.ERROR_MESSAGE.FOLDERNAME, pattern: {
                                                    value: /^.{1,}$/,
                                                    message: A12Y_CONST.ERROR_MESSAGE.FOLDERNAME
                                                }
                                            })}
                                            placeholder='Untitled File'
                                            className={errors.folderName ? 'inputColum errorInputBorderRed' : 'inputColum'}
                                            type='text'
                                            maxLength='255'
                                            id='folderName'
                                            onChange={(e) => handlefolderName(e.target.value)}
                                            value={folderName}
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter') {
                                                    e.preventDefault();
                                                    handleSubmit(onSubmit)();
                                                }
                                            }}
                                            onFocus={() => {
                                                setError("folderName", {
                                                    type: "manual",
                                                    message: "",
                                                });
                                            }}
                                        />
                                        <div className='errorRelativeRow'>{errors.folderName && <p className='errorMessage'>{errors.folderName.message}</p>}</div>
                                    </div>
                                    <div className="fullWidth textAlignRight marginTop30 documentPopUpButtonRow displayFlexCol" >
                                        <div className='widthAuto cancelButtonCol'><input id={A12Y_CONST.BUTTON_ID.DOCUMENT_POPUP_CANCEL} className={!isSubmitting ? "cancelButton1" : 'cancelButton1'} onClick={hidePopUp} type="button" value={A12Y_CONST.BUTTON_TEXT.GAURDIAN_PROFILE_PERSONAL_INFO_CANCEL} /></div>
                                        <div className='widthAuto createButtonCol marginLeft20'>
                                            <div className='loaderSpinner'>
                                                {loading ?
                                                    <Loading />
                                                    :
                                                    null
                                                }
                                                <input id={A12Y_CONST.BUTTON_ID.DOCUMENT_POPUP_RENAME} className={loading || folderName === '' || folderName === undefined || folderName === props?.selectedItem?.display_name ? "saveButtonDisable" : 'popUpNoButton'} disabled={loading || folderName === '' || folderName === props?.selectedItem?.display_name} type="button" onClick={handleSubmit(onSubmit)} value={A12Y_CONST.TEXT.RENAME} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                :
                null
            }
        </div>
    )
}

export default PopUpRenameComponent;
